import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function DetailTentor() {
  const [tentorData, setTentorData] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const { userId } = useParams(); // Ambil userId dari useParams
  // const API_BASE_URL = 'http://localhost:5000/api/admin';
  const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentor = async () => {
      if (!userId) return; // Tambahkan pengecekan jika userId tidak ada

      try {
        const response = await fetch(`${API_BASE_URL}/tentor/${userId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentorData(data);
      } catch (error) {
        console.error('Error fetching tentor details:', error);
        setFetchError('Failed to fetch tentor details.');
      }
    };

    fetchTentor();
  }, [userId]); // Tambahkan userId sebagai dependency

  if (fetchError) {
    return <p className="text-red-500 text-xs">{fetchError}</p>;
  }

  if (!tentorData) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Detail Tentor</h3>
      <div className="space-y-4 mb-2">
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama:</p>
          <p className="text-blueGray-600">{tentorData.nama}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2 ">
          <p className="font-semibold text-blueGray-600">Email:</p>
          <p className="text-blueGray-600">{tentorData.email}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Alamat:</p>
          <p className="text-blueGray-600">{tentorData.alamat}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nomor Telepon:</p>
          <p className="text-blueGray-600">{tentorData.telepon}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Ngaji:</p>
          <p className="text-blueGray-600">{tentorData.ngaji}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Kemampuan:</p>
          <p className="text-blueGray-600">{tentorData.kemampuan.join(', ')}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Pendidikan:</p>
          <p className="text-blueGray-600">{tentorData.pendidikan}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Pengalaman:</p>
          <p className="text-blueGray-600">{tentorData.pengalaman}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Ketersediaan:</p>
          {tentorData.ketersediaan.length ? (
            <ul className="list-disc pl-5">
              {tentorData.ketersediaan.map((item, index) => (
                <li key={index} className="text-blueGray-600">
                  {item.hari}: {item.waktu_mulai} - {item.waktu_selesai}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-blueGray-600">Tidak ada ketersediaan.</p>
          )}
        </div>
        <div>
          <a href="/admin/tentor">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Kembali
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
